<script>
import fetch from '@maxsystems/ui/api'

import { verifyAccess } from '../queries'
import LinkedTextFields from './LinkedTextFields'

export default {
  components: {
    LinkedTextFields
  },
  props: {
    challenge: {
      type: String,
      default: null
    },
    opportunityId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false,
    errorMsg: null,
    code: null
  }),
  methods: {
    update: async function () {
      const { opportunityId, challenge, code } = this
      if (!opportunityId || !challenge || !code) {
        throw new Error('opportunityId, challenge, and code required')
      }
      this.loading = true

      const { data } = await fetch(verifyAccess, { opportunityId, challenge, code: parseInt(code) })
      this.loading = false
      if (data?.verifyAccess?.token) {
        if (this.opportunityId !== data.verifyAccess.opportunity.id) {
          // this is a returning user
          await this.$store.dispatch('opportunity/get', data.verifyAccess.opportunity.id)
        }

        this.$emit('update:accessToken', data.verifyAccess.token)
        return
      }
      this.errorMsg = 'The token can not be validated. Please try again or click "RESEND CODE".'
      this.code = null
    }
  }
}
</script>

<template>
  <VCard
    class="v-card--verify-access"
    :loading="loading"
    :disabled="loading"
  >
    <VCardTitle class="text-h6 justify-center pt-8 pb-6">
      Two-Factor Authentication
    </VCardTitle>
    <VCardText>
      <LinkedTextFields
        v-model="code"
        :disabled="loading"
        @update="update"
      />
    </VCardText>
    <VCardSubtitle
      v-if="errorMsg"
      class="error--text"
    >
      {{ errorMsg }}
    </VCardSubtitle>
    <VCardSubtitle v-else>
      A message with a verification code has been sent to you.
      Enter the code to continue.
    </VCardSubtitle>
    <VCardActions class="justify-center">
      <VBtn
        text
        @click="$emit('resend')"
      >
        Resend code
      </VBtn>
    </VCardActions>
  </VCard>
</template>

<style lang="scss">
.v-card--verify-access {
  width: 25.5rem;
}
</style>
